(function () {
  var TRANSITION_MS = 500;
  var SWIPE_DECIDE = 8;    // px of movement before we lock in swipe direction
  var SWIPE_TRIGGER = 80;  // max px needed to change slide

  function initSlider(slider) {
    if (slider.dataset.initialized === 'true') return;

    var track = slider.querySelector('[data-fps-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    var count = slides.length;

    slider.dataset.initialized = 'true';
    if (count <= 1) return;

    var root = slider.closest('[data-fps-root]') || slider.parentNode;
    var prevBtn = root.querySelector('[data-fps-prev]');
    var nextBtn = root.querySelector('[data-fps-next]');

    // Clone first + last slides for seamless wrap-around in both directions.
    var firstClone = slides[0].cloneNode(true);
    var lastClone = slides[count - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    track.appendChild(firstClone);
    track.insertBefore(lastClone, slides[0]);

    var pos = 1; // first real slide (index 0 is the trailing-edge clone)
    var locked = false;

    function setX(p, animate) {
      track.style.transition = animate ? 'transform ' + TRANSITION_MS + 'ms ease' : 'none';
      track.style.transform = 'translateX(' + (-100 * p) + '%)';
    }

    setX(pos, false);

    function go(dir) {
      if (locked) return;
      locked = true;
      pos += dir;
      setX(pos, true);
    }

    track.addEventListener('transitionend', function () {
      if (pos === 0) {
        pos = count;
        setX(pos, false);
      } else if (pos === count + 1) {
        pos = 1;
        setX(pos, false);
      }
      locked = false;
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        go(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        go(1);
      });
    }

    // --- Touch / swipe support ---
    var startX = 0;
    var startY = 0;
    var deltaX = 0;
    var dragging = false;
    var decided = false;
    var horizontal = false;
    var slideW = 0;

    slider.addEventListener('touchstart', function (e) {
      if (locked || e.touches.length !== 1) return;
      var t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      deltaX = 0;
      dragging = true;
      decided = false;
      horizontal = false;
      slideW = slider.clientWidth || 1;
    }, { passive: true });

    slider.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var t = e.touches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;

      if (!decided) {
        if (Math.abs(dx) < SWIPE_DECIDE && Math.abs(dy) < SWIPE_DECIDE) return;
        decided = true;
        horizontal = Math.abs(dx) > Math.abs(dy);
        if (!horizontal) {
          dragging = false; // vertical intent — let the page scroll
          return;
        }
        track.style.transition = 'none';
      }

      if (horizontal) {
        if (e.cancelable) e.preventDefault();
        deltaX = dx;
        track.style.transform = 'translateX(' + ((-pos * slideW) + dx) + 'px)';
      }
    }, { passive: false });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      if (!horizontal) return;

      var threshold = Math.min(SWIPE_TRIGGER, slideW * 0.2);
      if (deltaX <= -threshold) {
        go(1);
      } else if (deltaX >= threshold) {
        go(-1);
      } else {
        setX(pos, true); // not far enough — snap back
      }
    }

    slider.addEventListener('touchend', endDrag);
    slider.addEventListener('touchcancel', endDrag);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sliders = scope.querySelectorAll('[data-fps-slider]');
    Array.prototype.forEach.call(sliders, initSlider);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
